// extracted by mini-css-extract-plugin
export default {"modalOverlay":"WJ-z","modalContent":"XJ-z","header":"YJ-z","close":"ZJ-z"};